import { createFileRoute, redirect } from "@tanstack/react-router";

import { settingsCloudRedirect } from "./settingsDiagnosticsRedirects";

/**
 * Kept as a redirect. Cloud bookmarks and desktop menus used this path when
 * Diagnostics lived under General.
 */
export const Route = createFileRoute("/settings/cloud")({
  beforeLoad: () => {
    throw redirect(settingsCloudRedirect());
  },
});
